import '../chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.NPSScoreChartView extends Monitoring.Views.Charts.ChartView
  id: 'nps-score-chart'
  className: 'processing item'
  template: JST['backbone/templates/monitoring/charts/generic_chart']
  scoreTemplate: JST['backbone/templates/monitoring/charts/plain_score_chart']

  events:
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'

  initialize: (@options = {}) ->
    @title = I18n.t('monitoring.dashboard.charts.nps_score')
    @searchQuery = @options.searchQuery
    @_settings = @options.settings
    @detractorColor = '#c0392b'
    @passiveColor = '#ff9800'
    @promoterColor = '#27ae60'
    @minScore = 0
    @maxScore = 10
    @scoreLabel = 'NPS'

  render: ->
    @$el.html @template
      title: @title
    @trigger('masonry')
    @

  afterAppend: ->
    @ajaxCall('/monitoring/api/charts/single_dimension', @getSearchQuery().toJSON(), (response) =>
      @groupedScores = @groupData(@parseData(response.series[0].data))
      @$el.removeClass('processing')
      npsScoreValue = @npsScore(@groupedScores)
      @$el.find('.chart').html @scoreTemplate
        score_label: @scoreLabel
        score_value: npsScoreValue
        score_class: @npsScoreClass(npsScoreValue)
      @groupedScores = @groupedScores.filter (score) => score.value > 0
      @$el.find('.chart').append(new Monitoring.Views.Charts.StackedHorizontalBarChartView(data: @groupedScores).render().el)
    )

  getSearchQuery: ->
    query = @searchQuery.deepCopy()
    query.set('dimension', 'nps')
    query

  destroy: ->
    super()
    Backbone.trigger('charts:closed:update')

  parseData: (data) =>
    scores = @initializeScores()
    _.each(data, (item) =>
      scores[item.code].y = item.y
    )
    scores

  groupData: (scores) =>
    detractors = 0
    passives = 0
    promoters = 0
    total = 0
    result = []
    _.each(scores, (item) =>
      total += item.y
      switch
        when item.code <= 6 then detractors += item.y
        when item.code in [7, 8] then passives += item.y
        when item.code in [9, 10] then promoters += item.y
    )

    [
      { code: 'promoters',  value: promoters, y: @labeledPercentageOf(promoters, total), color: @promoterColor },
      { code: 'passives',   value: passives, y: @labeledPercentageOf(passives, total), color: @passiveColor },
      { code: 'detractors', value: detractors, y: @labeledPercentageOf(detractors, total), color: @detractorColor }
    ]

  labeledPercentageOf: (value, total) =>
    parseFloat(value / total * 100).toFixed(2)

  npsScore: (data) =>
    parseFloat(data[0].y - data[2].y).toFixed(2)

  npsScoreClass: (npsScoreValue) =>
    switch
      when npsScoreValue == 0 then 'neutral'
      when npsScoreValue > 0  then 'positive'
      when npsScoreValue < 0  then 'negative'

  initializeScores: ->
    scores = []
    for i in [@minScore..@maxScore]
      scores.push {code: i, y: 0}
    scores
